import React, { Component, useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import { Grid, FormControlLabel, Switch, Checkbox } from '@material-ui/core';
import PublicPage from '../PublicPage';
import Typo from '../../components/CustomTypo';
import { portalCfg } from '../../../portal.router.config';
import Button from '../../components/ButtonCustom';
import { LinkRouter } from '../../components/Link';
import { Field, Form } from 'react-final-form';
import { SelectComponent, TextFieldComponent } from '../../components/FormElement';
import validators from '../../utils/validators';
import SocialComponent from '../../components/SocialComponent'
import { InformPasswordIcon, SwichGreenActiveIcon, SwichIcon } from '../../components/icons'
import { domainName, portal_config } from '../../../portal.config';
import { getAppCfg, getCountries } from '../../utils/common';

const lang_icon_en = portalCfg.publicPath + "/icons/usa_flag.png";
const MIN_LENGTH_PASSWORD = 8;

const styles = theme => ({
    container: {
        paddingTop: theme.spacing(10),
        paddingBottom: theme.spacing(10),
        [theme.breakpoints.down('sm')]: {
            paddingBottom: theme.spacing(2),
        },
    },
    marginTop: {
        marginTop: theme.spacing(2),
    },
    formLogin: {
        marginTop: theme.spacing(4),
        backgroundColor: theme.palette.background.box,//'#ffffff1f',
        borderRadius: 10,
        padding: theme.spacing(5, 15, 10, 15),
    },
    swichSmall: {
        marginTop: theme.spacing(2),
        resizeMode: 'contain',
        cursor: 'pointer'
    },
    inform: {
        cursor: 'pointer',
    },
    inform_password: {
        position: 'relative',
    },
    inform_password_desc: {
        padding: theme.spacing(3),
        backgroundColor: theme.palette.background.secondary,
        // marginTop: theme.spacing(3),
        borderRadius: theme.spacing(3),
        border: '1px solid ' + theme.palette.border.secondary,
        position: 'absolute',
        zIndex: 10,
    },
});

class RegisterEmailView extends Component {
    render() {
        const { classes, t, showAlert, onShowLoading, register_info, onReceiveMarketing, auth_support } = this.props;
        //console.log('RegisterEmailView auth_support==',auth_support)
        return (
            <PublicPage rightComponent={<RegisterViewComponent classes={classes} t={t}
                onSubmit={this.props.onSubmit}
                showAlert={showAlert}
                onShowLoading={onShowLoading}
                register_info={register_info}
                onReceiveMarketing={onReceiveMarketing}
                auth_support={auth_support}
                agreement_countries = {getCountries()}
                country_default = {this.props.country_default}
                onSelectCountry = {this.props.onSelectCountry}
                accept_policy={this.props.accept_policy}
                onChangeCheckboxPolicy={this.props.onChangeCheckboxPolicy}/>}
            />
        );
    }
}
function RegisterViewComponent(props) {
    const { classes, t, showAlert, onShowLoading, auth_support,onSelectCountry } = props;
    //console.log('RegisterViewComponent auth_support==',auth_support)
    return (
        <Grid xs={12} sm={12} md={12} item container>
            <Grid xs={12} sm={12} item container>
                <Typo variant='h2' color={portal_config[domainName].publicPagePrimaryColor?'onPrimary':'primary'} mg_bottom_md>{t('btn_register')}</Typo>
            </Grid>
            <Grid xs={12} item container direction="row">
                <Typo variant='body2' color={portal_config[domainName].publicPagePrimaryColor?'onPrimary':'primary'} center>{t('already_account')}&nbsp;</Typo>
                <LinkRouter to='login' variant='body2' size='sm' color={portal_config[domainName].publicPagePrimaryColor?null:'primary'}>{t('btn_login')}</LinkRouter>
            </Grid>
            <Grid xs={12} sm={12} item container justify='center'>
                <RegisterForm classes={classes} t={t} 
                    onSubmit={props.onSubmit} 
                    register_info={props.register_info} 
                    onReceiveMarketing={props.onReceiveMarketing} 
                    agreement_countries={props.agreement_countries} 
                    country_default = {props.country_default}
                    onSelectCountry = {onSelectCountry}
                    accept_policy={props.accept_policy}
                    onChangeCheckboxPolicy={props.onChangeCheckboxPolicy}
                    />
            </Grid>
            {(auth_support.facebook || auth_support.google) ? <SocialComponent showAlert={showAlert} onShowLoading={onShowLoading} auth_support={auth_support} /> : null}
        </Grid>
    )
}
function RegisterForm(props) {
    const { classes, t, country_default, onSelectCountry } = props;
    var appConfig = getAppCfg();
    var isEmailOtp = appConfig && appConfig.auth_support && appConfig.auth_support.email_otp;
    const [showInform, setShowInform] = useState(false);
    return (
        <Form
            onSubmit={props.onSubmit}
            render={({ handleSubmit, reset, submitting, pristine, values }) => (
                <Grid xs={12} container item className={classes.marginTop}>
                    <Field
                        name="first_name"
                        component={TextFieldComponent}
                        label={t('first_name')}
                        placeholder={t('enter_your_firstname')}
                        isEdit={true}
                        color='default'
                        validate={validators.composeValidators(validators.required)}
                    />
                    <Field
                        name="last_name"
                        component={TextFieldComponent}
                        label={t('last_name')}
                        placeholder={t('enter_your_lastname')}
                        isEdit={true}
                        color='default'
                        validate={validators.composeValidators(validators.required)}
                    />
                    <Field
                        name="username"
                        component={TextFieldComponent}
                        label={t('email')}
                        placeholder={t('email_input_placeholder')}
                        isEdit={true}
                        color='default'
                        validate={validators.composeValidators(validators.validEmail)}
                        autoFocus={true}
                    />
                    {portal_config[domainName].isRegisterCountry&&props.agreement_countries&&props.agreement_countries.length&&props.agreement_countries.length>1&&<Field
                        name="country"
                        component={SelectComponent}
                        label={t('country')}
                        selectData={props.agreement_countries}
                        defaultValueSelect={country_default?country_default:null}
                        valueSelect={props.register_info.country_agreement?props.register_info.country_agreement: country_default}
                        onSelectedChange={(event)=>onSelectCountry(event)}
                        color='default'
                        placeholder = {t('Select')}
                        //isEdit={mode==='add'?true:false}
                        isEdit={true}
                        />}
                    {!isEmailOtp&&<Field
                        name="password"
                        component={TextFieldComponent}
                        customLabel={true}
                        label={<Grid item xs={12} container className={classes.inform} onMouseEnter={()=> setShowInform(true)} onMouseLeave={()=> setShowInform(false)}>
                            <Typo mg_left_md variant="input_label" color="default">{t('password')}</Typo>
                            <Grid item style={{marginLeft: 10}}><InformPasswordIcon /></Grid>
                        </Grid>}
                        placeholder={t('enter_your_password')}
                        isEdit={true}
                        color='default'
                        validate={validators.composeValidators(validators.required)}
                        autoFocus={true}
                        type='password'
                    />}
                    {showInform && <Grid item xs={12} className={classes.inform_password}>
                        <Grid item className={classes.inform_password_desc}>
                            <Typo color='error'>{t('inform_password')}</Typo>
                            <Typo color='error'>{t('inform_password_1')}</Typo>
                            <Typo color='error'>{t('inform_password_2')}</Typo>
                            <Typo color='error'>{t('inform_password_3')}</Typo>
                            <Typo color='error'>{t('inform_password_4')}</Typo>
                            {/* <Typo color='error'>{t('inform_password_5')}</Typo> */}
                        </Grid>
                    </Grid>}
                    {!isEmailOtp&&<Field
                        name="confirm_password"
                        component={TextFieldComponent}
                        label={t('confirm_password')}
                        placeholder={t('confirm_password_placeholder')}
                        isEdit={true}
                        color='default'
                        //validate={validators.composeValidators(validators.required)}
                        autoFocus={true}
                        type='password'
                        validate={validators.composeValidators(validators.validNotMatch({compareValue: values.password, message: t('enter_same_password')},values.confirm_password))}
                    />}
                    <Field
                        name="referral_code"
                        component={TextFieldComponent}
                        label={t('referral_code')}
                        placeholder={t('referral_code_placeholder')}
                        isEdit={true}
                        color='default'
                        autoFocus={true}
                    />
                    <Typo mg_top_xs color={portal_config[domainName].publicPagePrimaryColor?'onPrimary':'primary'} variant='body1'>{t("receive_marketing_information")}</Typo>
                    <Grid container item xs={12} alignItems='center'>
                        <Typo mg_right_md mg_top_xs color={portal_config[domainName].publicPagePrimaryColor?'onPrimary':'primary'} variant='body1'>{t("setting_email")}</Typo>
                        <Grid onClick={() => props.onReceiveMarketing('email_opt_out', !props.register_info.email_opt_out)}>
                            {props.register_info.email_opt_out ? <SwichGreenActiveIcon className={classes.swichSmall} /> : <SwichIcon className={classes.swichSmall} />}
                        </Grid>
                        <Typo mg_top_xs mg_right_md mg_left_lg color={portal_config[domainName].publicPagePrimaryColor?'onPrimary':'primary'} variant='body1'>{t("setting_sms")}</Typo>
                        <Grid onClick={() => props.onReceiveMarketing('sms_opt_out', !props.register_info.sms_opt_out)}>
                            {props.register_info.sms_opt_out ? <SwichGreenActiveIcon className={classes.swichSmall} /> : <SwichIcon className={classes.swichSmall} />}
                        </Grid>
                    </Grid>
                    <Grid item xs={12} container direction='row'>
                        <Grid item xs={1} style={{marginLeft:-10, marginTop:-2}}>
                            <Checkbox 
                                checked={props.accept_policy}
                                onChange={props.onChangeCheckboxPolicy}/>
                        </Grid>    
                    <Grid item xs={11}>
                        <Typo color='error' variant='body2' mg_top_sm>{t("term_and_conditions_pre")}
                            <LinkRouter to='term-conditions' target="_blank" color={portal_config[domainName].publicPagePrimaryColor?null:'primary'} size='sm' >{t('term_and_conditions_upper')}</LinkRouter>
                            {" "}{t('and')}{" "}
                            <LinkRouter to='privacy-policy' target="_blank" color={portal_config[domainName].publicPagePrimaryColor?null:'primary'} size='sm'>{t('privacy_title')}</LinkRouter>
                        </Typo>
                    </Grid>
                    </Grid>


                    <Grid xs={12} item container justify='center' className={classes.marginTop}>
                        <Button color={portal_config[domainName].publicPagePrimaryColor?'dark':'primary'} fullWidth onClick={handleSubmit} disabled={!props.accept_policy}>{t('btn_register')}</Button>
                    </Grid>
                </Grid>
            )} />

    )
}
export default withStyles(styles)(withTranslation()(RegisterEmailView));